import { useAuth } from 'react-oidc-context';
import { useParams, useSearchParams } from 'react-router-dom';

import { setReferralCode } from '@/utils/referral';
import LoadingPage from './loading';

const ReferralPage = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const { referralCode } = useParams();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirect_to') ?? '/register';

  if (isLoading) {
    return <LoadingPage />;
  }

  if (!isAuthenticated && referralCode) {
    setReferralCode(referralCode);
  }

  window.location.assign(redirectTo);
};
ReferralPage.displayName = 'ReferralPage';

export default ReferralPage;
